import styles from "@/styles/components/button.module.scss";

import classNames from "classnames/bind";
const css = classNames.bind(styles);

export const Button = ({
  design = "primary",
  type = "button",
  children,
  disabled,
  onClick,
  className,
  loading,
  style,
}) => {
  const handleClick = (e) => {
    e.stopPropagation();
    onClick && onClick();
  };

  return (
    <button
      type={type}
      onClick={handleClick}
      className={css({
        button: true,
        loading: loading,
        [design]: true,
        [className]: className,
      })}
      disabled={disabled}
      style={style}
    >
      {loading ? (
        <div className={styles.loading}>
          <div className={styles.loader}></div>
        </div>
      ) : (
        children
      )}
    </button>
  );
};
